
/**
 * 主函数
 */
export function generateDataViewContent (opt, params) {
  const { queryField } = params

  if (queryField === 'flow_rate') {
    const html = handleFlowRate(opt, params)
    return { html, zoneCumulant: null }
  } else if (queryField === 'clean_flow') {
    return handleCleanFlow(opt, params)
  } else if (queryField === 'night_flow' || queryField === 'flow_day') {
    const html = handleNightFlowOrFlowDay(opt, params)
    return { html, zoneCumulant: null }
  } else {
    // 默认为 net_flow 或其他情况
    const html = handleNetFlow(opt, params)
    return { html, zoneCumulant: null }
  }
}

/**
 * 处理瞬时流量 (无总计行，进出水表分组，含合计列)
 */
function handleFlowRate (opt, params) {
  const { zoneName, queryFieldName, waterMeterData } = params
  const axisData = opt.xAxis[0].data
  const contrastdata = opt.xAxis[0].contrastdata
  const series = opt.series

  const inletNames = waterMeterData && waterMeterData.inletWaterMeter ? waterMeterData.inletWaterMeter : []
  const outletNames = waterMeterData && waterMeterData.outletWaterMeter ? waterMeterData.outletWaterMeter : []

  // 1. 对 Series 进行分类和排序
  const inletSeries = []
  const outletSeries = []
  const otherSeries = []
  const contrastSeries = []

  series.forEach(item => {
    if (inletNames.includes(item.name)) {
      inletSeries.push(item)
    } else if (outletNames.includes(item.name)) {
      outletSeries.push(item)
    } else if (item.name && item.name.includes('对比流量')) {
      contrastSeries.push(item)
    } else {
      otherSeries.push(item)
    }
  })

  // 2. 计算 colspan 和表头结构
  let hasContrastTime = false
  if (contrastSeries.length > 0) {
    hasContrastTime = true
  }

  // Title 覆盖: 时间列 + 其他列 + 对比列(含对比时间)
  const titleColspan = 1 + otherSeries.length + contrastSeries.length + (hasContrastTime ? 1 : 0)

  let row1Html = '<tr>'
  row1Html += `<th colspan="${titleColspan}" style="padding:5px 10px">${zoneName + queryFieldName}信息</th>`

  if (inletSeries.length > 0) {
    // 进水表列数 + 1个合计列
    row1Html += `<th colspan="${inletSeries.length + 1}" style="padding:5px 10px">进水表</th>`
  }
  if (outletSeries.length > 0) {
    // 出水表列数 + 1个合计列
    row1Html += `<th colspan="${outletSeries.length + 1}" style="padding:5px 10px">出水表</th>`
  }
  row1Html += '</tr>'

  // 3. 生成第二行表头 (具体列名)
  let row2Html = '<tr>'
  row2Html += '<td style="padding:5px 10px">查询时间</td>'

  let contrastTimeAdded = false

  // 其他 + 对比流量
  const prefixSeries = [...otherSeries, ...contrastSeries]
  prefixSeries.forEach(item => {
    if (item.name && item.name.includes('对比流量') && !contrastTimeAdded) {
      row2Html += '<td style="padding:5px 10px">对比时间</td>'
      contrastTimeAdded = true
    }
    row2Html += `<td style="padding: 5px 10px">${item.allname ? item.allname : item.name}</td>`
  })

  // 进水表列 + 合计
  if (inletSeries.length > 0) {
    inletSeries.forEach(item => {
      row2Html += `<td style="padding: 5px 10px">${item.allname ? item.allname : item.name}</td>`
    })
    row2Html += '<td style="padding: 5px 10px">合计</td>'
  }

  // 出水表列 + 合计
  if (outletSeries.length > 0) {
    outletSeries.forEach(item => {
      row2Html += `<td style="padding: 5px 10px">${item.allname ? item.allname : item.name}</td>`
    })
    row2Html += '<td style="padding: 5px 10px">合计</td>'
  }

  row2Html += '</tr>'

  // 4. 生成数据行
  let tableRows = ''
  for (let i = 0, l = axisData.length; i < l; i++) {
    let tdBodys = ''
    let rowContrastTimeAdded = false

    // --- 前置部分 (其他 + 对比) ---
    prefixSeries.forEach(item => {
      // 处理对比时间数据
      if (item.name && item.name.includes('对比流量') && !rowContrastTimeAdded) {
        tdBodys += `<td>${contrastdata[i] !== undefined ? contrastdata[i] : ''}</td>`
        rowContrastTimeAdded = true
      }
      let val = ''
      if (item.data && item.data[i] !== undefined && item.data[i] !== null) {
        if (typeof item.data[i] === 'object') {
          val = item.data[i].value !== undefined ? item.data[i].value : ''
        } else {
          val = item.data[i]
        }
      }
      tdBodys += `<td>${val}</td>`
    })

    // --- 进水表部分 ---
    if (inletSeries.length > 0) {
      let inletTotal = 0
      inletSeries.forEach(item => {
        let val = 0
        let displayVal = ''
        if (item.data && item.data[i] !== undefined && item.data[i] !== null) {
          if (typeof item.data[i] === 'object') {
            // 处理可能为 null 的情况
            const val = item.data[i].value
            displayVal = (val !== undefined && val !== null) ? val : ''
          } else {
            displayVal = (item.data[i] !== undefined && item.data[i] !== null) ? item.data[i] : ''
          }
        }
        // 累加计算
        val = parseFloat(displayVal) || 0
        inletTotal += val
        tdBodys += `<td>${displayVal}</td>`
      })
      // 添加进水表合计列
      tdBodys += `<td>${inletTotal.toFixed(2)}</td>`
    }

    // --- 出水表部分 ---
    if (outletSeries.length > 0) {
      let outletTotal = 0
      outletSeries.forEach(item => {
        let val = 0
        let displayVal = ''
        if (item.data && item.data[i] !== undefined && item.data[i] !== null) {
          if (typeof item.data[i] === 'object') {
            // 处理可能为 null 的情况
            const val = item.data[i].value
            displayVal = (val !== undefined && val !== null) ? val : ''
          } else {
            displayVal = (item.data[i] !== undefined && item.data[i] !== null) ? item.data[i] : ''
          }
        }
        // 累加计算
        val = parseFloat(displayVal) || 0
        outletTotal += val
        tdBodys += `<td>${displayVal}</td>`
      })
      // 添加出水表合计列
      tdBodys += `<td>${outletTotal.toFixed(2)}</td>`
    }

    tableRows += `<tr><td style="padding: 5px 10px">${axisData[i]}</td>${tdBodys}</tr>`
  }

  // 5. 组合完整表格
  let table = `<table border="1" style="width:95%;margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;"><tbody>${row1Html}${row2Html}${tableRows}</tbody></table>`

  return table
}

/**
 * 处理累积量 (双层表头，显示起始读数、结束读数和累积量)
 */
function handleCleanFlow (opt, params) {
  const { zoneName, queryFieldName, waterMeterData, cumulant } = params

  const axisData = opt.xAxis[0].data
  const contrastdata = opt.xAxis[0].contrastdata
  const series = opt.series

  const inletNames = waterMeterData && waterMeterData.inletWaterMeter ? waterMeterData.inletWaterMeter : []
  const outletNames = waterMeterData && waterMeterData.outletWaterMeter ? waterMeterData.outletWaterMeter : []

  // 1. 分类 Series
  const inletSeries = []
  const outletSeries = []
  const otherSeries = []

  series.forEach(item => {
    if (inletNames.includes(item.name)) {
      inletSeries.push(item)
    } else if (outletNames.includes(item.name)) {
      outletSeries.push(item)
    } else {
      otherSeries.push(item)
    }
  })

  const combinedSeries = [...otherSeries, ...inletSeries, ...outletSeries]

  // Prepare cumulant end values for the last row
  const cumulantMap = {}
  if (cumulant && cumulant.length > 1) {
    for (let i = 1; i < cumulant.length; i++) {
      const meterData = cumulant[i]
      if (meterData && meterData.length > 0) {
        const lastReading = meterData[meterData.length - 1]
        if (lastReading && lastReading.flowMeterNo) {
          cumulantMap[lastReading.flowMeterNo] = lastReading.value
        }
      }
    }
  }

  const lastRowEndVals = {}
  if (cumulant && axisData.length > 0) {
    const lastIdx = axisData.length - 1
    // First pass: Individual meters
    combinedSeries.forEach(s => {
      if (s.name !== '片区流量' && s.name !== '片区净流量') {
        const startVal = getSeriesValue(s.data[lastIdx])
        let endVal = cumulantMap[s.name]
        if (endVal === null || endVal === undefined || endVal === '') {
          endVal = startVal
        }
        lastRowEndVals[s.name] = endVal
      }
    })
    // Second pass: Zone Flow
    combinedSeries.forEach(s => {
      if (s.name === '片区流量' || s.name === '片区净流量') {
        let inletSum = 0
        inletSeries.forEach(ins => {
          inletSum += Number(lastRowEndVals[ins.name]) || 0
        })
        let outletSum = 0
        outletSeries.forEach(outs => {
          outletSum += Number(lastRowEndVals[outs.name]) || 0
        })
        lastRowEndVals[s.name] = (inletSum - outletSum).toFixed(2)
      }
    })
  }

  // 2. 检测是否有对比时间列
  let hasContrastTime = false
  let flag = true
  combinedSeries.forEach(function (item) {
    if (item.name == '对比流量') {
      hasContrastTime = true
    } else if (item.name && item.name.includes('对比流量') && flag) {
      hasContrastTime = true
      flag = false
    }
  })

  // 3. 构建表头
  const timeCols = 1 + (hasContrastTime ? 1 : 0)
  const hasSubGroups = inletSeries.length > 0 || outletSeries.length > 0
  const titleRowSpan = hasSubGroups ? 2 : 1

  let row1 = '<tr>'
  row1 += `<th rowspan="${titleRowSpan}" colspan="${timeCols}" style="padding:5px 10px">${zoneName + queryFieldName}信息</th>`

  // 其他仪表 (直接显示名字，占 titleRowSpan 行)
  otherSeries.forEach(item => {
    const name = item.allname ? item.allname : item.name
    row1 += `<th rowspan="${titleRowSpan}" colspan="3" style="padding:5px 10px">${name}</th>`
  })

  // 进水表分组
  if (inletSeries.length > 0) {
    row1 += `<th colspan="${inletSeries.length * 3}" style="padding:5px 10px">进水表</th>`
  }
  // 出水表分组
  if (outletSeries.length > 0) {
    row1 += `<th colspan="${outletSeries.length * 3}" style="padding:5px 10px">出水表</th>`
  }
  row1 += '</tr>'

  let row2 = ''
  if (hasSubGroups) {
    row2 += '<tr>'
    // 进水表名
    inletSeries.forEach(item => {
      const name = item.allname ? item.allname : item.name
      row2 += `<th colspan="3" style="padding:5px 10px">${name}</th>`
    })
    // 出水表名
    outletSeries.forEach(item => {
      const name = item.allname ? item.allname : item.name
      row2 += `<th colspan="3" style="padding:5px 10px">${name}</th>`
    })
    row2 += '</tr>'
  }

  // Row 3 (字段名)
  let row3 = '<tr>'
  row3 += '<td style="padding:5px 10px">查询时间</td>'
  if (hasContrastTime) {
    row3 += '<td style="padding:5px 10px">对比时间</td>'
  }
  combinedSeries.forEach(() => {
    row3 += '<td style="padding:5px 10px">起始读数</td><td style="padding:5px 10px">结束读数</td><td style="padding:5px 10px">累积量</td>'
  })
  row3 += '</tr>'

  // 4. 生成数据行
  let tableRows = ''
  for (let i = 0, l = axisData.length; i < l; i++) {
    let tr = `<tr><td style="padding: 5px 10px">${axisData[i]}</td>`
    if (hasContrastTime) {
      tr += `<td style="padding: 5px 10px">${contrastdata && contrastdata[i] !== undefined ? contrastdata[i] : ''}</td>`
    }

    for (let j = 0; j < combinedSeries.length; j++) {
      const s = combinedSeries[j]
      const startVal = getSeriesValue(s.data[i])

      // 最后一条记录：结束读数显示“未读取”，累积量置为 0
      if (i === l - 1) {
        tr += `<td>${startVal}</td><td>未读取</td><td>0</td>`
        continue
      }

      let endVal = 0
      if (i < l - 1) {
        endVal = getSeriesValue(s.data[i + 1])
      } else if (cumulant) {
        endVal = lastRowEndVals[s.name] || 0
      }

      const diff = (Number(endVal) - Number(startVal)).toFixed(2)
      tr += `<td>${startVal}</td><td>${endVal}</td><td>${diff}</td>`
    }
    tr += '</tr>'
    tableRows += tr
  }

  // 5. 生成总计行
  let totalRow = `<tr style="background-color: #f0f8ff; font-weight: bold;"><td style="padding: 5px 10px; background-color: #e6f7ff;">累积量</td>`
  if (hasContrastTime) {
    totalRow += `<td style="padding: 5px 10px; background-color: #e6f7ff;">对比累积量</td>`
  }

  let zoneCumulant = null
  for (let j = 0; j < combinedSeries.length; j++) {
    const s = combinedSeries[j]
    // 计算总差值
    const data = s.data
    const firstVal = getSeriesValue(data[0])
    let lastVal = getSeriesValue(data[data.length - 1])

    if (cumulant) {
      lastVal = lastRowEndVals[s.name] || 0
    }

    const diff = (Number(lastVal) - Number(firstVal)).toFixed(2)
    // 保存片区累积量
    if (s.name === '片区净流量' || s.name === '片区流量') {
      zoneCumulant = Number(diff)
    }
    // 合并3列: 起始 + 结束 + 累积
    totalRow += `<td colspan="3" style="padding: 5px 10px; background-color: #e6f7ff;">${diff}</td>`
  }
  totalRow += '</tr>'

  const tableHtml = `<table border="1" style="width:95%;margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;"><tbody>${row1}${row2}${row3}${tableRows}${totalRow}</tbody></table>`
  return { html: tableHtml, zoneCumulant: zoneCumulant }
}

function getSeriesValue (item) {
  if (item === undefined || item === null) return 0
  if (typeof item === 'object') return (item.value !== undefined && item.value !== null) ? item.value : 0
  if (item === '') return 0
  return item
}

/**
 * 处理夜间流量和日高峰流量 (包含总和列)
 */
function handleNightFlowOrFlowDay (opt, params) {
  const { zoneName, queryFieldName, initialColspan, th } = params
  const axisData = opt.xAxis[0].data
  const contrastdata = opt.xAxis[0].contrastdata
  const series = opt.series

  // 过滤掉基线系列用于计算基数（基线不参与总和计算，但会显示）
  const seriesWithoutBaseline = series.filter(item => item.name !== '基线')

  // 计算基数（不包含基线）
  let cardinality = seriesWithoutBaseline.length - 1
  let indexCardinality = 0
  for (let i = 0; i < seriesWithoutBaseline.length; i++) {
    if (seriesWithoutBaseline[i].name && seriesWithoutBaseline[i].name.includes('对比流量')) {
      cardinality = i
      indexCardinality = 2
      break
    }
  }

  // 1. 生成表头（显示所有系列，包括基线）
  let tdHeads = '<td  style="padding:5px 10px">查询时间</td>'
  let colspan = initialColspan
  let flag = true

  series.forEach(function (item, index) {
    if (item.name == '对比流量') {
      tdHeads += '<td  style="padding:5px 10px">对比时间</td>'
    } else if (item.name.includes('对比流量') && flag) {
      tdHeads += '<td  style="padding:5px 10px">对比时间</td>'
      flag = false
    }
    tdHeads += '<td style="padding: 5px 10px">' + (item.allname ? item.allname : item.name) + '</td>'

    // 总和列只在非基线系列后添加
    if (item.name !== '基线' && index != 0) {
      const nonBaselineIndex = seriesWithoutBaseline.findIndex(s => s.name === item.name)
      if (nonBaselineIndex != 0 && (nonBaselineIndex % cardinality) == indexCardinality) {
        tdHeads += '<td  style="padding:5px 10px">总和</td>'
        colspan += 1
      }
    }
  })

  // 2. 生成表格主体
  let tdBodys = ''
  let tableRows = ''
  const columnTotals = []
  for (var j = 0; j < series.length; j++) {
    columnTotals.push(0)
  }

  for (let i = 0, l = axisData.length; i < l; i++) {
    let flag2 = true
    for (let j = 0; j < series.length; j++) {
      const isBaseline = series[j].name === '基线'
      
      if (typeof series[j].data[i] == 'object') {
        if (series[j].data[i]) {
          const value = parseFloat(series[j].data[i].value) || 0
          tdBodys += '<td>' + series[j].data[i].value + '</td>'
          // 基线不计入columnTotals
          if (!isBaseline) {
            columnTotals[j] += value
          }
        } else {
          tdBodys += '<td></td>'
        }
      } else {
        if (series[j].name == '对比流量') {
          tdBodys += '<td>' + contrastdata[i] + '</td>'
          const value = parseFloat(series[j].data[i]) || 0
          tdBodys += '<td>' + series[j].data[i] + '</td>'
          columnTotals[j] += value
        } else {
          if (series[j].name.includes('对比流量') && flag2) {
            tdBodys += '<td>' + contrastdata[i] + '</td>'
            flag2 = false
          }
          const value = parseFloat(series[j].data[i]) || 0
          tdBodys += '<td>' + series[j].data[i] + '</td>'

          // 总和列（排除基线）
          if (!isBaseline && j != 0) {
            const nonBaselineIndex = seriesWithoutBaseline.findIndex(s => s.name === series[j].name)
            if (nonBaselineIndex != 0 && (nonBaselineIndex % cardinality) == indexCardinality) {
              let tdCount = 0
              // 计算总和时排除基线
              seriesWithoutBaseline.forEach(item => {
                if (item.data[i] !== undefined && item.data[i] !== null) {
                  tdCount += parseFloat(item.data[i]) || 0
                }
              })
              tdBodys += '<td>' + tdCount.toFixed(2) + '</td>'
            }
          }
          
          // 基线不计入columnTotals
          if (!isBaseline) {
            columnTotals[j] += value
          }
        }
      }
    }
    tableRows += '<tr><td style="padding: 5px 10px">' + axisData[i] + '</td>' + tdBodys + '</tr>'
    tdBodys = ''
  }

  // 3. 生成总计行
  let totalRow = `<tr style="background-color: #f0f8ff; font-weight: bold;"><td style="padding: 5px 10px; background-color: #e6f7ff;">总计</td>`
  let flag3 = true
  for (let j = 0; j < series.length; j++) {
    const isBaseline = series[j].name === '基线'
    
    if (series[j].name == '对比流量') {
      totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">对比总计</td>'
      totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">' + columnTotals[j].toFixed(2) + '</td>'
    } else if (series[j].name.includes("对比流量") && flag3) {
      totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">对比总计</td>'
      totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">' + columnTotals[j].toFixed(2) + '</td>'
      flag3 = false
    } else if (isBaseline) {
      // 基线列显示"-"表示不参与计算
      totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">-</td>'
    } else {
      totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">' + columnTotals[j].toFixed(2) + '</td>'
    }

    // 总和列（排除基线）
    if (!isBaseline && j != 0) {
      const nonBaselineIndex = seriesWithoutBaseline.findIndex(s => s.name === series[j].name)
      if (nonBaselineIndex != 0 && (nonBaselineIndex % cardinality) == indexCardinality) {
        let tdCount = 0
        // 计算总计时排除基线
        columnTotals.forEach((item, idx) => {
          if (series[idx].name !== '基线') {
            tdCount += item
          }
        })
        totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">' + tdCount.toFixed(2) + '</td>'
      }
    }
  }
  totalRow += '</tr>'

  // 4. 组合
  let table = `<table border="1" style="width:95%;margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;"><tbody><tr><th colspan="${colspan}" style="padding:5px 10px">${zoneName + queryFieldName}信息</th>${th}</tr><tr>${tdHeads}</tr>${tableRows}${totalRow}</tbody></table>`

  return table
}

/**
 * 处理净流量及其他默认情况 (标准累加总计)
 */
function handleNetFlow (opt, params) {
  const { zoneName, queryFieldName, waterMeterData } = params
  const axisData = opt.xAxis[0].data
  const contrastdata = opt.xAxis[0].contrastdata
  const series = opt.series

  const inletNames = waterMeterData && waterMeterData.inletWaterMeter ? waterMeterData.inletWaterMeter : []
  const outletNames = waterMeterData && waterMeterData.outletWaterMeter ? waterMeterData.outletWaterMeter : []

  // 1. Series 分类
  const inletSeries = []
  const outletSeries = []
  const otherSeries = []
  const contrastSeries = []

  series.forEach(item => {
    if (inletNames.includes(item.name)) {
      inletSeries.push(item)
    } else if (outletNames.includes(item.name)) {
      outletSeries.push(item)
    } else if (item.name && item.name.includes('对比流量')) {
      contrastSeries.push(item)
    } else {
      otherSeries.push(item)
    }
  })

  // 2. 表头构建
  let hasContrastTime = false
  if (contrastSeries.length > 0) {
    hasContrastTime = true
  }

  // Row 1: 大标题
  // 覆盖: 时间 + 其他仪表 + 对比仪表(含对比时间)
  const titleColspan = 1 + otherSeries.length + contrastSeries.length + (hasContrastTime ? 1 : 0)

  let row1Html = '<tr>'
  row1Html += `<th colspan="${titleColspan}" style="padding:5px 10px">${zoneName + queryFieldName}信息</th>`

  if (inletSeries.length > 0) {
    row1Html += `<th colspan="${inletSeries.length}" style="padding:5px 10px">进水表</th>`
  }
  if (outletSeries.length > 0) {
    row1Html += `<th colspan="${outletSeries.length}" style="padding:5px 10px">出水表</th>`
  }
  row1Html += '</tr>'

  // Row 2: 具体列名
  let row2Html = '<tr>'
  row2Html += '<td style="padding:5px 10px">查询时间</td>'

  let contrastTimeAdded = false
  const prefixSeries = [...otherSeries, ...contrastSeries]

  prefixSeries.forEach(item => {
    if (item.name && item.name.includes('对比流量') && !contrastTimeAdded) {
      row2Html += '<td style="padding:5px 10px">对比时间</td>'
      contrastTimeAdded = true
    }
    row2Html += `<td style="padding: 5px 10px">${item.allname ? item.allname : item.name}</td>`
  })

  // 进水表名
  inletSeries.forEach(item => {
    row2Html += `<td style="padding: 5px 10px">${item.allname ? item.allname : item.name}</td>`
  })
  // 出水表名
  outletSeries.forEach(item => {
    row2Html += `<td style="padding: 5px 10px">${item.allname ? item.allname : item.name}</td>`
  })
  row2Html += '</tr>'

  // 3. 数据行生成
  // 合并后的处理顺序: prefixSeries -> inletSeries -> outletSeries
  const finalSeriesOrder = [...prefixSeries, ...inletSeries, ...outletSeries]
  let tableRows = ''

  // 用于计算合计行
  const columnTotals = new Array(finalSeriesOrder.length).fill(0)

  for (let i = 0, l = axisData.length; i < l; i++) {
    let tdBodys = ''
    let rowContrastTimeAdded = false

    // 遍历所有 Series (已按顺序)
    finalSeriesOrder.forEach((item, index) => {
      // 处理对比时间
      if (item.name && item.name.includes('对比流量') && !rowContrastTimeAdded) {
        tdBodys += `<td>${contrastdata[i] !== undefined ? contrastdata[i] : ''}</td>`
        rowContrastTimeAdded = true
      }

      // 获取值
      let val = 0
      let displayVal = ''
      if (item.data && item.data[i] !== undefined && item.data[i] !== null) {
        if (typeof item.data[i] === 'object') {
          const v = item.data[i].value
          displayVal = (v !== undefined && v !== null) ? v : ''
          val = parseFloat(v) || 0
        } else {
          displayVal = item.data[i]
          val = parseFloat(item.data[i]) || 0
        }
      }

      columnTotals[index] += val
      tdBodys += `<td>${displayVal}</td>`
    })

    tableRows += `<tr><td style="padding: 5px 10px">${axisData[i]}</td>${tdBodys}</tr>`
  }

  // 4. 总计行
  let totalRow = `<tr style="background-color: #f0f8ff; font-weight: bold;"><td style="padding: 5px 10px; background-color: #e6f7ff;">总计</td>`

  let totalRowContrastTimeAdded = false
  finalSeriesOrder.forEach((item, index) => {
    if (item.name && item.name.includes('对比流量') && !totalRowContrastTimeAdded) {
      totalRow += '<td style="padding: 5px 10px; background-color: #e6f7ff;">对比总计</td>'
      totalRowContrastTimeAdded = true
    }
    totalRow += `<td style="padding: 5px 10px; background-color: #e6f7ff;">${columnTotals[index].toFixed(2)}</td>`
  })
  totalRow += '</tr>'

  // 5. 组合
  let table = `<table border="1" style="width:95%;margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;"><tbody>${row1Html}${row2Html}${tableRows}${totalRow}</tbody></table>`

  return table
}
